var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 7.5C13.75 4.04812 10.9519 1.25 7.5 1.25C4.04812 1.25 1.25 4.04812 1.25 7.5C1.25 10.9519 4.04812 13.75 7.5 13.75C10.9519 13.75 13.75 10.9519 13.75 7.5ZM7.5 3.90625C7.62432 3.90625 7.74355 3.95564 7.83146 4.04354C7.91936 4.13145 7.96875 4.25068 7.96875 4.375V8.125C7.96875 8.24932 7.91936 8.36855 7.83146 8.45646C7.74355 8.54436 7.62432 8.59375 7.5 8.59375C7.37568 8.59375 7.25645 8.54436 7.16854 8.45646C7.08064 8.36855 7.03125 8.24932 7.03125 8.125V4.375C7.03125 4.25068 7.08064 4.13145 7.16854 4.04354C7.25645 3.95564 7.37568 3.90625 7.5 3.90625ZM7.5 10.625C7.66576 10.625 7.82473 10.5592 7.94194 10.4419C8.05915 10.3247 8.125 10.1658 8.125 10C8.125 9.83424 8.05915 9.67527 7.94194 9.55806C7.82473 9.44085 7.66576 9.375 7.5 9.375C7.33424 9.375 7.17527 9.44085 7.05806 9.55806C6.94085 9.67527 6.875 9.83424 6.875 10C6.875 10.1658 6.94085 10.3247 7.05806 10.4419C7.17527 10.5592 7.33424 10.625 7.5 10.625Z",
    fill: "#DB3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcons);
export default __webpack_public_path__ + "static/media/errorIcons.6571b4ae5f9fc452632c8aea11d21ec3.svg";
export { ForwardRef as ReactComponent };